import { Dispatch, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import BlueFullWidthButton from 'components/BlueFullWidthButton/BlueFullWidthButton';
import styled from 'styled-components/macro';

import { useDialog } from '../../../../utils/dialog';
import paperRoll from '../../assets/img9.png';
import { StyledCard, StyledTitle } from './styled';


interface Props {
    currentStateInfo: any;
    showUpdateStateDialog: () => void;
    setIsSelfAssessmentDialogOpen: Dispatch<SetStateAction<boolean>>;
}

const StyledImg = styled.img`
    & {
        filter: brightness(100%);
        transition: filter 0.4s ease;
    }

    &:hover {
        filter: brightness(85%);
    }

    &:active {
        filter: brightness(75%);
        transition: filter 0.01s ease;
    }
`;

const Card8 = (props: Props) => {
    const { currentStateInfo, showUpdateStateDialog, setIsSelfAssessmentDialogOpen } = props;
    const [openDialog, closeDialog] = useDialog();

    const { t } = useTranslation();

    const { showAutoAssessmentDialog, next, text } = currentStateInfo;

    const onClick = useCallback(() => {
        if (showAutoAssessmentDialog) {
            openDialog({
                title: t('dialogs.request_audit.title'),
                message: t('dialogs.request_audit.message'),
                actions: [
                    {
                        text: t('dialogs.generic.no'),
                        color: 'primary',
                        action: () => {
                            closeDialog();

                            setTimeout(() => {
                                openDialog({
                                    title: t('dialogs.request_audit.title'),
                                    message: (
                                        <>
                                            {t('dialogs.request_audit.self_assesment_suggestion')}

                                            <Button variant='contained' color='primary' style={{ padding: '10px 15px', margin: '18px auto 8px', fontSize: '1.10em', display: 'block' }} disabled={!showUpdateStateDialog} onClick={() => {
                                                closeDialog();
                                                setIsSelfAssessmentDialogOpen(true);
                                            }}>
                                                {t('dialogs.request_audit.go_to_self_assessment')}
                                            </Button>

                                            <Button variant='outlined' color='primary' style={{ margin: '12px auto 0', display: 'block', fontSize: '0.85em' }} onClick={() => {
                                                closeDialog();

                                                setTimeout(() => {
                                                    showUpdateStateDialog();
                                                }, 250);
                                            }}>
                                                {t('dialogs.request_audit.ignore_self_assessment')}
                                            </Button>
                                        </>
                                    ),
                                    actions: []
                                });
                            }, 250);
                        }
                    },
                    {
                        text: t('dialogs.generic.yes'),
                        color: 'primary',
                        action: () => {
                            closeDialog();

                            setTimeout(() => {
                                showUpdateStateDialog();
                            }, 250);
                        }
                    },
                ]
            });
        } else {
            showUpdateStateDialog();
        }
    }, [showAutoAssessmentDialog, closeDialog, openDialog, setIsSelfAssessmentDialogOpen, showUpdateStateDialog, t]);

    // if (!next) return null;

    return (
        <StyledCard variant='outlined'>
            <CardContent style={{ height: '100%' }}>
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <StyledTitle style={{ fontSize: '1.65rem', fontWeight: 500, marginBottom: '4px' }}>
                        {t('pages.dashboard.cards.audit.title')}
                    </StyledTitle>

                    <StyledTitle style={{ fontSize: '1rem' }}>
                        {t('pages.dashboard.cards.audit.description')}
                    </StyledTitle>

                    <StyledImg src={paperRoll} style={{ maxWidth: '100%', maxHeight: '120px', display: 'block', margin: '24px auto 12px', cursor: 'pointer' }} onClick={(next !== null && text !== null) ? onClick : undefined} />

                    <div style={{ flexGrow: 1 }} />

                    {next !== null && text !== null && (
                        <BlueFullWidthButton variant='contained' color='primary' style={{ width: 'calc(100% + 44px)', margin: '24px -22px -18px' }} onClick={onClick}>
                            {text}
                        </BlueFullWidthButton>
                    )}
                </div>
            </CardContent>
        </StyledCard>
    );
};

export default Card8;
